import { en, cn } from './en'
import { formatRes } from './tool'
const isUTC8 = new Date().getTimezoneOffset() / 60  === -8

export default {
  en
}

export const defaultI18n =  isUTC8 ? 'cn': 'en'
export const defaultData = formatRes(cn)